namespace TabAurous.Inventory {
    export interface StockAllocationRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        AutoPosting?: boolean;
        TermsId?: number;
        Remark?: string;
        CompanyId?: number;
        EmployeeId?: number;
        FinancialYearId?: number;
        ItemDetails?: StockAllocationItemsRow[];
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        UserId?: number;
        RefTransId?: number;
        ProductItemImage?: string;
        PostingDate?: string;
        IsPosted?: boolean;
        Username?: string;
    }

    export namespace StockAllocationRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Inventory.StockAllocation';
        export const deletePermission = 'Inventory:StockAllocation:Delete';
        export const insertPermission = 'Inventory:StockAllocation:Add';
        export const readPermission = '*';
        export const updatePermission = 'Inventory:StockAllocation:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            AutoPosting = "AutoPosting",
            TermsId = "TermsId",
            Remark = "Remark",
            CompanyId = "CompanyId",
            EmployeeId = "EmployeeId",
            FinancialYearId = "FinancialYearId",
            ItemDetails = "ItemDetails",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            UserId = "UserId",
            RefTransId = "RefTransId",
            ProductItemImage = "ProductItemImage",
            PostingDate = "PostingDate",
            IsPosted = "IsPosted",
            Username = "Username"
        }
    }
}
